<template>
  <div>
    <div class="mt-2">
      <div v-for="(template, index) in itineraryTemplate" :key="index">
        <label class="text-field-label">Day {{ index + 1 }}</label>
        <div class="itinerary-template">
          <div class="itinerary-template--input">
            <v-autocomplete
              class="mt-2"
              v-model="itineraryTemplate[index]"
              :items="itineraries"
              :loading="fetchingItineraries"
              filled
              item-text="name"
              item-value="itinerary_activity_template_id"
              @change="updateItineraryTemplate(index, $event)"
              :error-messages="index === 0 ? errorMessage : ''"
            >
              <template v-slot:append-outer>
                <v-btn
                  color="normal"
                  @click="getItineraries()"
                  :loading="fetchingItineraries"
                  icon
                >
                  <v-icon>
                    {{ icons.refresh }}
                  </v-icon>
                </v-btn>
              </template>
            </v-autocomplete>
          </div>
          <v-btn
            class="ml-5 mt-4"
            color="error"
            fab
            dark
            small
            v-if="index !== 0"
            @click="removeItineraryTemplate(index)"
          >
            <v-icon small>{{ icons.delete }}</v-icon>
          </v-btn>
        </div>
      </div>
      <v-btn
        text
        class="text-capitalize font-weight-bold text-primary"
        @click="addItineraryTemplate"
      >
        <v-icon>{{ icons.plusCircle }}</v-icon
        >Add Route
      </v-btn>
    </div>
  </div>
</template>

<script>
// import PlaceAutocomplete from '@/components/PlaceAutocomplete'
import { mdiTrashCanOutline, mdiPlusCircleOutline, mdiRefresh } from '@mdi/js'
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    itineraryTemplate: {
      type: Array
    },

    errorMessage: {
      type: Array
    }
  },

  data() {
    return {
      icons: {
        delete: mdiTrashCanOutline,
        plusCircle: mdiPlusCircleOutline,
        refresh: mdiRefresh
      }
    }
  },

  computed: {
    ...mapState({
      itineraries: state => state.itinerary.list,
      fetchingItineraries: state => state.itinerary.fetchingList
    })
  },

  created() {
    this.getItineraries()
  },

  methods: {
    ...mapActions({
      getItineraries: 'itinerary/getAllItineraries'
    }),

    addItineraryTemplate() {
      this.$emit('add')
    },

    removeItineraryTemplate(index) {
      this.$emit('remove', index)
    },

    updateItineraryTemplate(index, value) {
      this.$emit('update', {
        id: index,
        value: value
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.itinerary-template {
  display: flex;
  flex-direction: row;

  &--input {
    width: 430px;
  }
}
</style>
